module.exports = __webpack_public_path__ + "media/images/more-icon-20aae8e512e50031da15bac65d54c351.svg";